
/**
 * Object to specify variables for DEV environment
 * @property {boolean} production Boolean to specify if the environment is production env
 * @property {string} apisServerUrl Main API server URL
 * @property {number} apisPort Port for the main API server (0 if using default HTTPS port)
 * @property {string} identityServerUrl Identity/Auth server URL
 * @property {number} identityPort Port for the identity server
 * @property {string} baseUrl App base URL (Cloudflare Pages URL)
 * @property {string} appBaseHref Base href for app routing
 * @property {string} identityBaseHref Base href for identity routing
 */
export const environment = {
  production: false,
  apisServerUrl: 'https://172.24.32.11',
  apisPort: 0,
  identityServerUrl: 'https://172.24.32.11',
  identityPort: 9001,
  baseUrl: 'https://promsy-front-r5.pages.dev/',
  appBaseHref: '',
  identityBaseHref: '',
};
